import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Button, Modal, message } from "antd";
import {
  FileAddOutlined,
  EditOutlined,
  DeleteOutlined,
  DownloadOutlined,
} from "@ant-design/icons";

import { useEditorContext } from "../../hooks/useEditorContext";
import { AddDocumentModal } from "../ModalForm";

import PDFPreview from "../../components/PdfPreview";

interface Documents {
  groupId?: any;
  memberId?: any;
  documents: any;
  handleAddDocument?: Function;
  handleDownloadDocument?: any;
  handleDeleteDocument: Function;
}

const AdminDocumentList: React.FC<Documents> = ({
  groupId,
  memberId,
  documents,
  handleAddDocument,
  handleDownloadDocument,
  handleDeleteDocument,
}) => {
  const { setEditorContent, setEditorUpdate } = useEditorContext();
  const [show, setShow] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [documentId, setDocumentId] = useState("");

  const navigate = useNavigate();

  const handleAdd = () => {
    if (memberId) {
      setShow(true);
    } else {
      setEditorUpdate(false);
      setEditorContent("");
      navigate(`/admin/groups/${groupId}/document`);
    }
  };

  const handleDownload = (document: any) => {
    handleDownloadDocument(document);
  };

  const handleEdit = (document: any) => {
    setEditorContent(document);
    setEditorUpdate(true);
    navigate(`/admin/groups/${groupId}/document`);
  };

  const handleOk = (id: string) => {
    setIsModalOpen(false);
    handleDeleteDocument(id);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const showDeleteModal = (id: string) => {
    setIsModalOpen(true);
    setDocumentId(id);
  };

  const showModal = () => {
    setShow(!show);
  };

  return (
    <>
      {documents.map((document: any) => (
        <Col span={4} key={document.id}>
          <div className="document-item">
            <h5>{document.Name}</h5>
            {memberId && (
              <>
                <PDFPreview pdfUrl={document.Link} />
                <div style={{ display: "flex" }}>
                  <DownloadOutlined
                    className="document-edit"
                    onClick={() => handleDownload({ ...document })}
                    style={{ paddingRight: "4px" }}
                  />
                </div>
              </>
            )}

            {groupId && (
              <div style={{ display: "flex" }}>
                <EditOutlined
                  className="document-edit"
                  onClick={() => handleEdit({ ...document })}
                  style={{ paddingRight: "4px" }}
                />
                <DeleteOutlined
                  onClick={() => showDeleteModal(document.id)}
                  className="document-delete"
                />
              </div>
            )}
          </div>
        </Col>
      ))}

      <Col span={4} onClick={handleAdd}>
        <div className="document-item-add">
          <FileAddOutlined className="document-icon" />
        </div>
      </Col>

      <AddDocumentModal
        show={show}
        showModal={showModal}
        handleAdd={handleAddDocument}
        memberId={memberId}
      />

      <Modal
        title="Confirm Remove"
        open={isModalOpen}
        onOk={() => handleOk(documentId)}
        onCancel={handleCancel}
      >
        <p>Are you sure you want to remove this document?</p>
      </Modal>
    </>
  );
};

export default AdminDocumentList;
